<template>
    <div
        v-if="image"
        class="card card--hover rounded"
    >
        <div v-if="lazy">
            <img
                v-if="image"
                v-lazy="image"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image hidden lg:block"
            >

            <img
                v-if="hoverImage"
                v-lazy="hoverImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image card__image--hover hidden lg:block"
            >

            <img
                v-if="mediumImage"
                v-lazy="mediumImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image hidden md:block lg:hidden"
            >

            <img
                v-if="smallImage"
                v-lazy="smallImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image block md:hidden"
            >
        </div>
        <div v-else>
            <img
                v-if="image"
                :src="image"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image hidden lg:block"
            >

            <img
                v-if="hoverImage"
                :src="hoverImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image card__image--hover hidden lg:block"
            >

            <img
                v-if="mediumImage"
                :src="mediumImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image hidden md:block lg:hidden"
            >

            <img
                v-if="smallImage"
                :src="smallImage"
                :class="{ 'card__image--half-height' : halfImage }"
                class="card__image block md:hidden"
            >
        </div>

        <div
            v-if="isNew"
            class="card__new-banner hidden md:inline-block"
        >
            NEW
        </div>

    </div>
</template>

<script>
export default {

    props: {
        image: {
            type: String,
            default: null,
        },
        hoverImage: {
            type: String,
            default: null,
        },
        mediumImage: {
            type: String,
            default: null,
        },
        smallImage: {
            type: String,
            default: null,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        halfImage: {
            type: Boolean,
            default: false,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
    .card {
        @apply overflow-hidden relative select-none transition-fast cursor-pointer;

        @media (hover: hover) {
            &:hover {
                .card__new-banner {
                    @apply opacity-0;
                }

                .card__image--hover {
                    @apply opacity-100;
                }
            }
        }

        &__new-banner {
            @apply absolute bg-primary py-2 text-center text-white font-bold transition-slow z-20;
            transform: rotate(-45deg);
            top: 10px;
            left: -70px;
            width: 200px;

            &:after {
                content: "";
                left: 0;
                top: -98%;
                @apply bg-primary absolute w-full h-full;
            }
        }

        &__image {
            object-fit: cover;
            object-position: center;
            @apply w-full transition-fast;

            &--hover {
                @apply absolute opacity-0 transition-slow z-10 w-full;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>
